import {Box, Grid, Paper, Typography} from '@mui/material';
import React from 'react';
import {sectionPaperStyling} from './estimate-view-v4';

export const SectionHeader = (props: { title: string; subtitle?: string; testId?: string }) => {
  const {title, subtitle, testId} = props;
  return (
      <Box mb={2}>
        <Typography variant="subtitle2" test-id={testId}>
          {title}
        </Typography>
        {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
        )}
      </Box>
  );
}

export const HeaderSection = ({
                         title,
                         subtitle,
                         estimateId,
                         lastUpdateDt,
                         patientDOB,
                         patientName,
                       }: {
  title: string
  subtitle: string
  estimateId: string
  lastUpdateDt: string
  patientName: string
  patientDOB: string
}) => {

  return (
      <Box mb={4}>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xs={12} md={7}>
            <Typography variant="h4" sx={{fontSize: '1.8rem'}}>
              {title}
            </Typography>
            <Typography variant="h4">
              {subtitle}
            </Typography>
          </Grid>
          <Grid
              item xs={12}
              md={3}
          >
            <Typography variant="body2">Estimate
              #
              : {estimateId}</Typography>
            <Typography variant="body2">
              Date Last Updated
              : {lastUpdateDt}
            </Typography>

          </Grid>
        </Grid>
        <Paper
            variant="outlined"
            sx={{
              mt: 3,
              p: 2.5,
              backgroundColor: '#f5f5f5',
              ...sectionPaperStyling
            }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <Typography variant="h4">
                <strong>Name
                  : </strong> {patientName}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="h4">
                <strong>Date of Birth
                  : </strong> {patientDOB}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>
  );
}